import { DataTestId } from '@mews-commander/enums';
import { Bill } from '@mews-commander/data-access';
import { SpacingMediumTopBottom } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';
import SelectAllCheckbox from './SelectAllCheckbox';
import RebateSelectAllItemsLabel from './RebateSelectAllItemsLabel';

interface RebateSelectAllItemsProps {
    billId: Bill['id'];
}

const RebateSelectAllItems = ({ billId }: RebateSelectAllItemsProps) => (
    <SpacingMediumTopBottom>
        <Stack itemAlignment="center">
            <SelectAllCheckbox billId={billId} data-test-id={DataTestId.RebatesSelectAll}>
                <RebateSelectAllItemsLabel billId={billId} />
            </SelectAllCheckbox>
        </Stack>
    </SpacingMediumTopBottom>
);

export default RebateSelectAllItems;
